import { useAppSelector } from '../reduxHooks'
import getObjectKey from '../../lib/object/getObjectKey'

export function useInitialTourFacets(placeId: string, region: string): App.StatefulData<App.Tours.TourSearchFacets> | undefined {
  const key = getObjectKey({ placeId, region })
  return useAppSelector((state) => state.tour.tourFacets[key])
}
